<template>
  <div>
    <div
      :style="{
        display: 'flex',

        borderBottom: '1px solid #ccc',
        padding: '15px',
        cursor: 'pointer',
      }"
      @click="$router.push(`/regalos/campaign/${campaign_id}/idea/${idea_id}/option/${option.id}/view`)"
    >
      <div style="margin-right: 10px">
        <ImagesStacked :images="[option.image_url]" :size="65" :max-visible="2" />
      </div>
      <div style="width: 100%">
        <div style="font-size: 110%; font-weight: bold">
          {{ trimText(option.title || 'Sin título', 50) }}
        </div>
        {{ option.price }} EUR
        <p v-if="option.description">
          {{ trimText(option.description, 100) }}
        </p>

        <div v-if="option.returned">
          <v-chip color="warning">Devuelto</v-chip>
        </div>
        <div v-else-if="option.purchased">
          <v-chip color="success" v-if="campaign.split_spend">Comprado ({{ usernickname(option.paidBy) }})</v-chip>
          <v-chip color="success" v-if="!campaign.split_spend">Comprado</v-chip>
        </div>
        <div v-else-if="option.discarded">
          <v-chip color="error">Descartado</v-chip>
        </div>
      </div>
      <div>
        <v-btn icon x-large><v-icon>mdi-chevron-right</v-icon></v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { friends } from './regalos-data'
import ImagesStacked from './ImagesStacked.vue'
export default {
  components: {
    ImagesStacked,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
    idea_id: {
      type: String,
      default: '',
    },
    option: {
      type: Object,
      default() {
        return {}
      },
    },
    campaign: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    usernickname(username) {
      if (!username) return '???'
      const f = friends([], '')
      const u = f.find((x) => x.username == username)
      if (u) return u.name
      return username
    },
    trimText(text, len = 100) {
      if (!text) return ''
      if (text.length > len + 5) return text.slice(0, len) + '...'
      return text
    },
  },
}
</script>

<style lang="scss" scoped></style>
